import {AfterViewInit, Component, OnInit } from '@angular/core';
import { RouterModule} from '@angular/router';
import { NavbarComponent } from "./components/navbar/navbar.component";
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'my-app';
  isAuthenticated = false
  constructor() {
    console.log("app component loaded")
  }

  // ngOnInit(){
  //   this.isAuthenticated = !!localStorage.getItem('authToken')
  // }

  ngOnInit() {
    this.checkAuth();
    window.addEventListener('storage', () => this.checkAuth());
  }

  checkAuth() {
    this.isAuthenticated = !!localStorage.getItem('authToken');
  }

  ngAfterViewInit() {
    this.loadTemplateScripts();
  }

  loadTemplateScripts() {
    const script = document.createElement('script');
    script.src = 'assets/js/main.js';
    script.defer = true;
    document.body.appendChild(script);
  }

}
 